import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from 'components/button/Button'

export const SShareItems = styled.div<{ isModal?: boolean }>`
  display: grid;
  grid-gap: 0.625rem;
  grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));

  ${({ isModal }) =>
    isModal &&
    css`
      grid-template-columns: 1fr;
    `}
`

export const SButton = styled(Button)(
  css`
    & > div:first-of-type {
      left: 1rem;
      width: 1.75rem;
      height: 1.75rem;

      & svg {
        width: 1.75rem;
        height: 1.75rem;
      }
    }
  `,
  (props) =>
    props.variant === 'round'
      ? {
          height: '3rem',
        }
      : {}
)
